// extracted by mini-css-extract-plugin
export default {"bold":"VotesList_bold__1HUcy","polls_question_label":"VotesList_polls_question_label__VFUJ0","polls_add_poll_btn":"VotesList_polls_add_poll_btn__JvLMq"};